<script setup>
import { ref, reactive, defineProps, defineEmits, onMounted, watch } from "vue";
import LogDrillDown from "./LogDrillDown.vue";
import BreadcrumbSeperator from "@/components/BreadcrumbSeperator.vue";

const props = defineProps({
  license: Object,
  updates: Array,
  type: String,
});

const emit = defineEmits(["back"]);

const selectedUpdate = ref("");
const headersUpdates = [
  { title: "App Name", value: "name", sortable: true },
  { title: "Version", value: "version", sortable: true },
  { title: "Install Count", value: "count", sortable: true },
];
const sortBy = ref([{ key: "count", order: "desc" }]);
function selectUpdate(xxx, row) {
  selectedUpdate.value = row.item;
}
const searchField = ref("");
</script>

<template>
  <template v-if="!selectedUpdate">
    <div style="display: flex; align-items: center" class="mb-2">
      <BreadcrumbEmit label="Dashboard" @click="emit('Back')" />
      <BreadcrumbSeperator />
      <BreadcrumbEmit
        v-if="props.type == 'Failed'"
        label="Updates Failed"
        notLink
      />
      <BreadcrumbEmit v-else label="Updates Installed" notLink />
    </div>
    <h1>
      {{ props.type == "Failed" ? "Updates Failed" : "Updates Installed" }}
    </h1>
    <v-row>
      <v-col cols="3">
        <v-sheet rounded class="ma-1" elevation="1">
          <v-text-field
            v-model="searchField"
            hide-details
            prepend-inner-icon="mdi-magnify"
            density="compact"
            variant="solo"
            placeholder="Search anything..."
            clearable
          ></v-text-field>
        </v-sheet>
      </v-col>
    </v-row>
    <v-sheet rounded="lg" elevation="1" class="ma-1">
      <v-data-table
        :search="searchField"
        :headers="headersUpdates"
        :items="props.updates"
        v-model:sort-by="sortBy"
        :must-sort="true"
        @click:row="selectUpdate"
      />
    </v-sheet>
  </template>
  <template v-else>
    <div style="display: flex; align-items: center" class="mb-2">
      <BreadcrumbEmit label="Dashboard" @click="emit('Back')" />
      <BreadcrumbSeperator />
      <BreadcrumbEmit label="Updates Installed" @click="selectedUpdate = ''" />
      <BreadcrumbSeperator />
      <BreadcrumbEmit :label="selectedUpdate.name" notLink />
    </div>
    <LogDrillDown
      :selected="selectedUpdate"
      :license="props.license"
      @Back="selectedUpdate = ''"
    />
  </template>
</template>
